<template>
  <basic-container id="parkblacklist20220108">
    <el-form
        :model="searchForm"
        ref="searchFormRef"
        label-width="100px"
        label-suffix=":"
        v-show="searchBoxFlag"
      >
        <el-row :gutter="24">
          <el-col :span="6">
            <el-form-item label="车场名称" prop="parkingLotId">
              <selectSearch :canClearable="true" v-model="searchForm.parkingLotId" :dicData="spaceList"></selectSearch>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item label="车牌号" prop="plateNumber">
              <el-input
                clearable
                v-model="searchForm.plateNumber"
                placeholder="车牌号"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="车主姓名" prop="driverName">
              <el-input
                clearable
                v-model="searchForm.driverName"
                placeholder="车主姓名"
                maxlength="20"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="单位信息" prop="companyName">
              <el-input
                clearable
                v-model="searchForm.companyName"
                placeholder="单位信息"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="生效日期" prop="address">
              <el-date-picker
              style="width:48%;"
              v-model="searchForm.startTime"
              type="date"
              value-format="yyyy-MM-dd 00:00:00"
              range-separator="到"
              placeholder="开始时间"
            >
            </el-date-picker>
            <span style="width:4%;display: inline-block;text-align: center;">到</span>
            <el-date-picker
              style="width:48%;"
              v-model="searchForm.endTime"
              type="date"
              value-format="yyyy-MM-dd 23:59:59"
              range-separator="到"
              placeholder="结束时间"
            >
            </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <div style="float:right">
              <el-button type="primary" icon="el-icon-search" @click="searchRecord" size="small">
                搜索
              </el-button>
              <el-button icon="el-icon-delete" @click="searchClear" size="small"> 清空 </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>

    <el-tabs v-model="activeName" @tab-click="handleClick">
    <el-tab-pane label="白名单" name="0">
      <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="onLoad"
      @on-load="onLoad"
    >
      <template slot="menuLeft">
        <el-button
        type="primary"
          size="small"
          icon="el-icon-plus"
          plain
          @click="openAdd"
          >新增
        </el-button>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-plus"
          v-if="permissionList.addBatchBtn"
          @click="openFormDialog(0)"
        >批 量 新 增
        </el-button>
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.parkblacklist_delete"
          @click="handleDelete"
          >删 除
        </el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-s-operation"
          plain
          v-if="permissionList.DelayBtn"
          @click="handleDelay"
          >延期
        </el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-upload"
          plain
          v-if="permissionList.importBtn"
          @click="handleImport"
          >批量导入
        </el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-upload"
          plain
          v-if="permissionList.exportBtn"
          @click="handleExport"
          >导出
        </el-button>
      </template>
      <template slot-scope="scope" slot="menu">
          <el-button   type="text" size="small" @click="editRecord(scope.row)">编辑 </el-button>
        </template>
      <template slot="remark" slot-scope="scope">
        <wq-overHidden :content="scope.row.remark">
          <span>{{ scope.row.remark }}</span>
        </wq-overHidden>
      </template>
    </avue-crud>
      <addBlackWhiteCarPlusForm ref="addBlackWhiteCarPlusForm" @update="callBackSearch"></addBlackWhiteCarPlusForm>
    </el-tab-pane>
    <el-tab-pane label="黑名单" name="1">
      <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data2"
      :page.sync="page2"
      :permission="permissionList"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud2"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange2"
      @search-reset="searchReset2"
      @selection-change="selectionChange"
      @current-change="currentChange2"
      @size-change="sizeChange2"
      @refresh-change="onLoad2"
      @on-load="onLoad2"
    >
    <template slot="parkingLotIdSearch">
        <selectSearch  v-model="query2.parkingLotId" :dicData="spaceList"></selectSearch>
      </template>
      <template slot="menuLeft">
        <el-button
        type="primary"
          size="small"
          icon="el-icon-plus"
          plain
          @click="openAdd"
          >新增
        </el-button>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-plus"
          v-if="permissionList.addBatchBtn"
          @click="openFormDialog(1)"
        >批 量 新 增
        </el-button>
        <el-button
          type="danger"
          size="small"
          icon="el-icon-delete"
          plain
          v-if="permission.parkblacklist_delete"
          @click="handleDelete2"
          >删 除
        </el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-s-operation"
          plain
          v-if="permissionList.DelayBtn"
          @click="handleDelay2"
          >延期
        </el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-upload"
          plain
          v-if="permissionList.importBtn"
          @click="handleImport2"
          >批量导入
        </el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-upload"
          plain
          v-if="permissionList.exportBtn"
          @click="handleExport"
          >导出
        </el-button>
      </template>
      <template slot-scope="scope" slot="menu">
       <el-button   type="text" size="small" @click="editRecord(scope.row)">编辑 </el-button>
     </template>
      <template slot="remark" slot-scope="scope">
        <wq-overHidden :content="scope.row.remark">
          <span>{{ scope.row.remark }}</span>
        </wq-overHidden>
      </template>
    </avue-crud>
    </el-tab-pane>
  </el-tabs>


    <el-dialog
      id="delayDialog"
      title="延期"
      :visible.sync="showDelayDialogFlag"
      :modal-append-to-body="false"
    >
      <div class="el-property-dialog-div">
        <avue-form
          ref="delayDialog"
          v-model="delayForm"
          :option="delayOption"
          @submit="submitDelay"
        >
          <template slot-scope="scope" slot="menuForm">
            <el-button icon="el-icon-back" @click="cancelDelay">返回</el-button>
          </template>
        </avue-form>
      </div>
    </el-dialog>
    <el-dialog
      id="importDialog"
      title="导入"
      :visible.sync="showImportDialogFlag"
      :modal-append-to-body="false"
    >
      <div class="el-property-dialog-div">
        <avue-form
          ref="delayDialog"
          v-model="importForm"
          :option="importOption"
          @submit="submitImport"
        >
        <template slot="parkingLotId">
        <selectSearch  v-model="importForm.parkingLotId" :dicData="spaceList"></selectSearch>
      </template>
          <template slot-scope="scope" slot="menuForm">
            <el-button
              icon="el-icon-download"
              @click="downExcel"
              v-show="permissionList.downloadBtn"
              >模板下载</el-button
            >
            <el-button icon="el-icon-close" @click="cancelImport">关闭</el-button>
          </template>
          <template slot="fileName" slot-scope="scope">
            <el-upload
              accept=".xls,.xlsx"
              limit="1"
              style="display: inline-block; vertical-align: top"
              ref="upload"
              action=""
              :auto-upload="false"
              :http-request="uploadFile"
              :on-change="changeFile"
              :on-remove="removeFile"
            >
              <el-button size="small" type="primary">请选择文件</el-button>
            </el-upload>
          </template>
        </avue-form>
      </div>
    </el-dialog>
    <hr-dialog :title="parkblackTitle" :allowFull="false" width="60%" :visible.sync="parkblackVisible">
        <template slot="body">
          <Form
            v-if="parkblackVisible"
            :spaceId='searchForm.parkingLotId'
            @success="parkblackSuccess"
            :type="activeName"
            :model="parkblackModel"
            :row="formRow"
            @cancle="parkblackCancle"
          ></Form>
        </template>
      </hr-dialog>
  </basic-container>
</template>

<script>

import {
  add,
  getDetail,
  getList,
  remove,
  update,
  syncBlacklist,
  delayBlacklist,
  submitImportFile,
} from '@/api/v4ward/park/blacklistv2/parkblacklist';
import { getSpaceTree } from '@/api/v4ward/carv2/carparkspace';
import { nodeTreeByParentId } from '@/api/v4ward/carv2/carmonth';
import { mapGetters } from 'vuex';
import { getToken } from '@/util/auth';
import Form from './form';
import addBlackWhiteCarPlusForm from "./addBlackWhiteCarPlus-form.vue"
export default {
  components: {addBlackWhiteCarPlusForm,
    Form},
  data() {
    return {
      searchBoxFlag:true,
      searchForm:{
        parkingLotId:"",
        startTime:'',
        endTime:'',
        plateNumber:'',
        driverName:'',
        companyName:'',
        blackType:0
      },
      exportForm:{},
      formparkingLotId:"",
      parkblackTitle:'新增',
      formRow:{},
      parkblackModel:'add',
      parkblackVisible:false,
      activeName:'0',
      reWrite: false,
      spaceList: [],
      tempParkingLotId: '',
      firstDisplayFlag: false,
      showDelayDialogFlag: false,
      showImportDialogFlag: false,
      importDone: null,
      form: {},
      delayForm: {},
      importForm: {},
      query: {
        parkingLotId: '',
        startDateRange: '',
        endDateRange: '',
        plateNumber: '',
        driverName: '',
      },
      query2: {
        parkingLotId: '',
        startDateRange: '',
        endDateRange: '',
        plateNumber: '',
        driverName: '',
      },
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      page2: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      selectionList2: [],
      importOption: {
        submitText: '导入',
        emptyBtn: false,
        column: [
          {
            label: '车场名称',
            prop: 'parkingLotId',
            formslot: true,
            type: 'select',
            clearable: false,
            span: 12,
            props: {
              label: 'title',
              value: 'id',
              disabled: 'disabled',
            },
            dicData:[],
            rules: [
              {
                required: true,
                message: '请选择车场',
                trigger: 'change',
              },
            ],
          },
          {
            label: '车场区域',
            prop: 'regionIds',
            span: 12,
            multiple: true,
            checkStrictly: true,
            type: 'tree',
            dataType: 'string',
            dicData: [],
            props: {
              label: 'title',
              value: 'id',
            },
            rules: [
              {
                required: true,
                message: '请选择区域',
                trigger: 'change',
              },
            ],
          },
          {
            label: '类型',
            prop: 'blackType',
            span: 12,
            type: 'select',
            value: 0,
            dicData: [
              { label: '白名单', value: 0 },
              { label: '黑名单', value: 1 },
            ],
            rules: [
              {
                required: true,
                message: '请选择名单类型',
                trigger: 'change',
              },
            ],
          },
          {
            label: '授权类型',
            prop: 'parkAreaRightType',
            span: 12,
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=park_area_right_type',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
            value: 0,
            display: true,
            rules: [
              {
                required: true,
                message: '请选择授权类型',
                trigger: 'change',
              },
            ],
          },
          {
            label: '文件导入',
            prop: 'fileName',
            formslot: true,
            span: 24,
            rules: [{ required: true, message: '请选择导入表格', trigger: 'change' }],
          },
        ],
      },
      delayOption: {
        submitText: '保存',
        emptyBtn: false,
        column: [
          {
            label: '结束时间',
            prop: 'endDate',
            span: 24,
            type: 'date',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd 23:59:59',
            rules: [
              {
                required: true,
                message: '请选择结束时间',
                trigger: 'change',
              },
            ],
          },
        ],
      },
      option: {
        height: 'auto',
        calcHeight: 55,
        tip: true,
        searchShow: true,
        searchMenuSpan: 24,
        border: true,
        index: true,
        viewBtn: true,
        refreshBtn: true,
        selection: true,
        selectionClearBtn: true,
        dialogClickModal: false,
        columnBtn: true,
        labelWidth: 90,
        indexLabel: '#',
        dialogWidth: '40%',
        addBtn:false,
        editBtn:false,
        span: 24,
        stripe: true,
        column: [
          {
            label: '车场名称',
            prop: 'parkingLotId',
            clearable: false,
            searchClearable:false,
            type: 'select',
            span: 12,
            searchSpan: 6,
            editDisabled: true,
            dicData:[],
            searchslot:true,
            props: {
              label: 'title',
              value: 'id',
              disabled: 'disabled',
            },
            rules: [
              {
                required: true,
                message: '请选择车场',
                trigger: 'change',
              },
            ],
          },
          {
            label: '区域名称',
            prop: 'regionNames',
            span: 12,
            editDisplay: false,
            addDisplay: false,
            viewDisplay: true,
            overHidden: true,
          },
          {
            label: '车场区域',
            prop: 'regionIds',
            span: 12,
            hide: true,
            editDisplay: true,
            addDisplay: true,
            viewDisplay: false,
            multiple: true,
            checkStrictly: true,
            type: 'tree',
            dataType: 'string',
            dicData: [],
            props: {
              label: 'title',
              value: 'id',
            },
            rules: [
              {
                required: true,
                message: '请选择区域',
                trigger: 'change',
              },
            ],
          },
          {
            label: '车牌号',
            prop: 'plateNumber',
            placeholder: '请输入车牌号',
            span: 12,
            searchSpan: 6,
            maxlength: 8,
            rules: [
              {
                required: true,
                message: '请输入车牌',
                trigger: 'blur',
              },
              {
                required: true,
                pattern: this.$validation.carPlate,
                message: '车牌格式不对',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '车主姓名',
            prop: 'driverName',
            placeholder: '请输入车主名称',
            span: 12,
            searchSpan: 6,
            maxlength: 32,
            rules: [
              {
                required: true,
                message: '请输入姓名',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '车主电话',
            prop: 'mobile',
            span: 12,
            rules: [
              {
                required: true,
                message: '请输入手机号码',
                trigger: 'change',
              },
              {
                required: true,
                pattern: this.$validation.phone,
                message: '请输入正确的手机号',
                trigger: 'change',
              },
            ],
          },
          {
            label: '单位信息',
            prop: 'companyName',
            span: 12,
            maxlength: 32,
          },
          {
            label: '开始时间',
            prop: 'startDate',
            span: 12,
            type: 'date',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd 00:00:00',
            rules: [
              {
                required: true,
                message: '请选择开始时间',
                trigger: 'change',
              },
            ],
          },
          {
            label: '生效时间',
            prop: 'startDateRange',
            span: 24,
            searchSpan: 12,
            searchRange: true,
            hide: true,
            display: false,
            type: 'daterange',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
          },
          {
            label: '结束时间',
            prop: 'endDate',
            span: 12,
            type: 'date',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd 23:59:59',
            rules: [
              {
                required: true,
                message: '请选择结束时间',
                trigger: 'change',
              },
              {
                validator: (rule, value, callback) => {
                  var dateStart = Date.parse(this.form.startDate);
                  var dateEnd = Date.parse(value);
                  if (dateStart >= dateEnd) {
                    callback(new Error('结束时间必须大于开始时间！'));
                  } else {
                    callback();
                  }
                },
                trigger: 'change',
              },
            ],
          },

          {
            //0未生效，1生效，2失效
            label: '状态',
            prop: 'status',
            type: 'select',
            hide: true,
            display: false,
            value: 1,
            dicData: [
              { label: '停用', value: 0 },
              { label: '启用', value: 1 },
            ],
            props: {
              label: 'label',
              value: 'value',
            },
            rules: [
              {
                required: true,
                message: '请输入状态',
                trigger: 'change',
              },
            ],
          },

          {
            hide: true,
            label: '类型',
            prop: 'blackType',
            span: 12,
            type: 'select',
            value: 0,
            dicData: [
              { label: '白名单', value: 0 },
              { label: '黑名单', value: 1 },
            ],
            rules: [
              {
                required: true,
                message: '请选择名单类型',
                trigger: 'change',
              },
            ],
          },
          {
            hide: true,
            label: '授权类型',
            prop: 'parkAreaRightType',
            span: 12,
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=park_area_right_type',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
           value: 0,
            display: true,
            rules: [
              {
                required: true,
                message: '请选择授权类型',
                trigger: 'change',
              },
            ],
          },
          {
            label: '备注',
            prop: 'remark',
            type: 'textarea',
            span: 24,
            slot: true,
            minRows: 2,
            maxlength: 100,
            // overHidden: true,
            showWordLimit: true,
          },
          {
            label: '附件',
            prop: 'imgUrl',
            hide: true,
            type: 'upload',
            fileSize: 1024 * 1024,
            accept: ['.jpg', '.png'],
            listType: 'picture-img',
            propsHttp: {
              res: 'data',
              url: 'link',
            },
            action: '/api/v4ward/oss/customEndpoint/put-file',
            tip: '只能上传jpg/png格式的图片，且不超过1MB',
            span: 12,
            row: true,
            uploadError: (error, column) => {
              this.$message.error('上传失败，只能上传jpg/png格式的图片，且不超过1MB');
              console.log(error, column);
            },
          },
        ],
      },
      option2: {
        height: 'auto',
        calcHeight: 55,
        tip: true,
        searchShow: true,
        searchMenuSpan: 24,
        border: true,
        index: true,
        viewBtn: true,
        refreshBtn: true,
        selection: true,
        selectionClearBtn: true,
        dialogClickModal: false,
        columnBtn: true,
        labelWidth: 90,
        indexLabel: '#',
        dialogWidth: '40%',
        span: 24,
        stripe: true,
        column: [
          {
            label: '车场名称',
            prop: 'parkingLotId',
            clearable: false,
            type: 'select',
            span: 12,
            searchSpan: 6,
            editDisabled: true,
            props: {
              label: 'title',
              value: 'id',
              disabled: 'disabled',
            },
            rules: [
              {
                required: true,
                message: '请选择车场',
                trigger: 'change',
              },
            ],
          },
          {
            label: '区域名称',
            prop: 'regionNames',
            span: 12,
            editDisplay: false,
            addDisplay: false,
            viewDisplay: true,
            overHidden: true,
          },
          {
            label: '车场区域',
            prop: 'regionIds',
            span: 12,
            hide: true,
            editDisplay: true,
            addDisplay: true,
            viewDisplay: false,
            multiple: true,
            checkStrictly: true,
            type: 'tree',
            dataType: 'string',
            dicData: [],
            props: {
              label: 'title',
              value: 'id',
            },
            rules: [
              {
                required: true,
                message: '请选择区域',
                trigger: 'change',
              },
            ],
          },
          {
            label: '车牌号',
            prop: 'plateNumber',
            placeholder: '请输入车牌号',
            span: 12,
            searchSpan: 6,
            maxlength: 8,
            rules: [
              {
                required: true,
                message: '请输入车牌',
                trigger: 'blur',
              },
              {
                required: true,
                pattern: this.$validation.carPlate,
                message: '车牌格式不对',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '车主姓名',
            prop: 'driverName',
            placeholder: '请输入车主名称',
            span: 12,
            searchSpan: 6,
            maxlength: 32,
            rules: [
              {
                required: true,
                message: '请输入姓名',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '车主电话',
            prop: 'mobile',
            span: 12,
            rules: [
              {
                required: true,
                message: '请输入手机号码',
                trigger: 'change',
              },
              {
                required: true,
                pattern: this.$validation.phone,
                message: '请输入正确的手机号',
                trigger: 'change',
              },
            ],
          },
          {
            label: '单位信息',
            prop: 'companyName',
            span: 12,
            maxlength: 32,
          },
          {
            label: '开始时间',
            prop: 'startDate',
            span: 12,
            type: 'date',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd 00:00:00',
            rules: [
              {
                required: true,
                message: '请选择开始时间',
                trigger: 'change',
              },
            ],
          },
          {
            label: '生效时间',
            prop: 'startDateRange',
            span: 24,
            searchSpan: 12,
            searchRange: true,
            hide: true,
            display: false,
            type: 'daterange',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd',
          },
          {
            label: '结束时间',
            prop: 'endDate',
            span: 12,
            type: 'date',
            format: 'yyyy-MM-dd',
            valueFormat: 'yyyy-MM-dd 23:59:59',
            rules: [
              {
                required: true,
                message: '请选择结束时间',
                trigger: 'change',
              },
              {
                validator: (rule, value, callback) => {
                  var dateStart = Date.parse(this.form.startDate);
                  var dateEnd = Date.parse(value);
                  if (dateStart >= dateEnd) {
                    callback(new Error('结束时间必须大于开始时间！'));
                  } else {
                    callback();
                  }
                },
                trigger: 'change',
              },
            ],
          },

          {
            //0未生效，1生效，2失效
            label: '状态',
            prop: 'status',
            type: 'select',
            hide: true,
            display: false,
            value: 1,
            dicData: [
              { label: '停用', value: 0 },
              { label: '启用', value: 1 },
            ],
            props: {
              label: 'label',
              value: 'value',
            },
            rules: [
              {
                required: true,
                message: '请输入状态',
                trigger: 'change',
              },
            ],
          },

          {
            hide: true,
            label: '类型',
            prop: 'blackType',
            span: 12,
            type: 'select',
            value: 1,
            dicData: [
              { label: '白名单', value: 0 },
              { label: '黑名单', value: 1 },
            ],
            rules: [
              {
                required: true,
                message: '请选择名单类型',
                trigger: 'change',
              },
            ],
          },
          {
            hide: true,
            label: '授权类型',
            prop: 'parkAreaRightType',
            span: 12,
            type: 'select',
            dicUrl: '/api/blade-system/dict/dictionary?code=park_area_right_type',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'number',
          value:0,
            display: true,
            rules: [
              {
                required: true,
                message: '请选择授权类型',
                trigger: 'change',
              },
            ],
          },
          {
            label: '备注',
            prop: 'remark',
            type: 'textarea',
            span: 24,
            slot: true,
            minRows: 2,
            maxlength: 100,
            // overHidden: true,
            showWordLimit: true,
          },
          {
            label: '附件',
            prop: 'imgUrl',
            hide: true,
            type: 'upload',
            fileSize: 1024 * 1024,
            accept: ['.jpg', '.png'],
            listType: 'picture-img',
            propsHttp: {
              res: 'data',
              url: 'link',
            },
            action: '/api/v4ward/oss/customEndpoint/put-file',
            tip: '只能上传jpg/png格式的图片，且不超过1MB',
            span: 12,
            row: true,
            uploadError: (error, column) => {
              this.$message.error('上传失败，只能上传jpg/png格式的图片，且不超过1MB');
              console.log(error, column);
            },
          },
        ],
      },
      data: [],
      data2:[],
      temporarySearch:{},
    };
  },
  watch: {
    'form.blackType'(val) {
      let column = this.findObject(this.option.column, 'parkAreaRightType');
      if (0 == val) {
        column.display = true;
      } else {
        column.display = false;
        this.form.parkAreaRightType = '';
      }
    },
    'importForm.blackType'(val) {
      let column = this.findObject(this.importOption.column, 'parkAreaRightType');
      if (0 == val) {
        column.display = true;
      } else {
        column.display = false;
        this.importForm.parkAreaRightType = '';
      }
    },
    'form.parkingLotId'() {
      nodeTreeByParentId(this.form.parkingLotId).then((res) => {
        const column = this.findObject(this.option.column, 'regionIds');

        setTimeout(() => {
          column.dicData = res.data;
          if (this.vdui.isEmpty(this.form.regionIds) && this.vdui.isNotEmpty(column.dicData)) {
            this.form.regionIds = column.dicData[0].id;
          }
        });
      });
    },
    'importForm.parkingLotId'() {
      nodeTreeByParentId(this.importForm.parkingLotId).then((res) => {
        const column = this.findObject(this.importOption.column, 'regionIds');
        setTimeout(() => {
          column.dicData = res.data;
          if (
            this.vdui.isEmpty(this.importForm.regionIds) &&
            this.vdui.isNotEmpty(column.dicData)
          ) {
            this.importForm.regionIds = column.dicData[0].id;
          }
        });
      });
    },
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.parkblacklist_add, false),
        viewBtn: this.vaildData(this.permission.parkblacklist_view, false),
        delBtn: this.vaildData(this.permission.parkblacklist_delete, false),
        editBtn: this.vaildData(this.permission.parkblacklist_edit, false),
        syncBtn: this.vaildData(this.permission.parkblacklist_sync, false),
        DelayBtn: this.vaildData(this.permission.parkblacklist_delay, false),
        importBtn: this.vaildData(this.permission.parkblacklist_import, false),
        downloadBtn: this.vaildData(this.permission.parkblacklist_template, false),
        exportBtn: this.vaildData(this.permission.parkblacklist_export, false),
        addBatchBtn: this.vaildData(this.permission.parkblacklist_add_batch, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  created() {
    this.option.height = this.bodyHeight - 510;
    this.option2.height = this.bodyHeight - 510;
    getSpaceTree(null, 2).then((data) => {
      this.spaceList = data.data;
      if (this.spaceList.length > 0) {
        this.searchForm.parkingLotId = this.spaceList[0].id;
        this.onLoad();
      }
    });
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        document
          .querySelector(
            '#avue-view  div.avue-crud > div.avue-crud__menu > div.avue-crud__right > button:nth-child(3)'
          )
          .addEventListener('click', () => {
            if (this.option.height == this.bodyHeight - 470) {
              this.option.height = this.bodyHeight - 280;
            } else {
              this.option.height = this.bodyHeight - 470;
            }
            this.$refs.crud.getTableHeight();
          });
      }, 1000);
    });
  },
  methods: {
    callBackSearch(blackType){
      if(blackType == 0){
        this.onLoad();
      }else{
        this.onLoad2();
      }
    },
    openFormDialog(blackType){
      this.$refs.addBlackWhiteCarPlusForm.openDialog(blackType);
    },
    handleClick(){
     this.searchForm.blackType = this.activeName
      if(this.activeName==0){
        this.onLoad()
      }else{
        this.onLoad2()
      }
      // this.$nextTick(()=>{
      //   this.$refs.crud.doLayout()
      //   this.$refs.crud2.doLayout()
      // })
    },
    searchClear(){
      this.tool.clearObject(this.searchForm,'parkingLotId');
    },
    parkblackCancle(){
      this.parkblackVisible = false
    },
    parkblackSuccess() {
      this.parkblackVisible = false
      this.onLoad()
      this.onLoad2();
    },
    openAdd(){
      console.log(this.activeName)
      this.parkblackTitle = "新增"
      this.parkblackModel='add'
      this.parkblackVisible = true
    },
    editRecord(row){
      this.parkblackTitle = "编辑"
      this.parkblackModel='edit'
      this.formRow = row
      this.parkblackVisible = true
    },
    uploadFile(f) {
      const formData = new FormData();
      formData.append('parkingLotId', this.importForm.parkingLotId);
      formData.append('regionIds', this.importForm.regionIds);
      formData.append('blackType', this.importForm.blackType);
      formData.append('parkAreaRightType', this.importForm.parkAreaRightType);
      formData.append('file', f.file);
      submitImportFile(formData)
        .then((response) => {
          if (response.code === 200) {
            this.$message.success('导入成功!');
            this.onLoad();
            this.showImportDialogFlag = false;
            this.importDone();
          }
        })
        .catch(({ err }) => {
          console.log(err);
          this.showImportDialogFlag = false;
          this.importDone();
        });
    },
    changeFile(file, fileList) {
      console.log('重选了文件');
      this.importForm.file = file;
      this.importForm.fileName = file.name;
    },
    removeFile() {
      this.importForm.fileName = '';
      this.importForm.file = null;
    },
    submitImport(form, done) {
      this.importDone = done;
      this.$refs.upload.submit();
    },

    cancelImport() {
      console.log('取消');
      this.showImportDialogFlag = false;
    },
    //excel模板导出使用这个方法
    downExcel() {
      import('@/vendor/Export2Excel.js').then((excel) => {
        const tHeader = [
          '序号',
          '车牌号',
          '车主姓名',
          '车主电话',
          '单位信息',
          '开始时间',
          '结束时间',
          '备注',
        ];
        const data = [
          [
            '1',
            '鄂A360N1',
            '张三',
            '12343232341',
            '长江物业',
            '2021-05-13',
            '2021-06-13',
            '日期为文本框日期',
          ],
        ];
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: '黑白名单模板',
        });
      });
    },
    downloadTemplate() {
      const fileName = '黑白名单模板.xls';
      console.log('下载模板...');
      axios
        .get('/api/park/blacklist/template', { responseType: 'blob' })
        .then((res) => {
          let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
          let downloadElement = document.createElement('a');
          downloadElement.href = window.URL.createObjectURL(blob); // 创建一个DOMString
          downloadElement.download = fileName;
          downloadElement.click();
          window.URL.revokeObjectURL(blob); // 释放 DOMString  ,解除内存占用
        })
        .catch((error) => {
          console.error(error);
        });
    },
    handleExport() {
      window.open(
        `/api/park/blacklist/export/v2?${
          this.website.tokenHeader
        }=${getToken()}&parkingLotId=${this.exportForm.parkingLotId}
        &startTime=${this.exportForm.startTime}
        &endTime=${this.exportForm.endTime}
        &plateNumber=${this.exportForm.plateNumber}
        &companyName=${this.exportForm.companyName}
        &blackType=${this.exportForm.blackType}
        &driverName=${this.exportForm.driverName}`
      );
    },
    handleDelay() {
      //延期
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.delayForm.ids = this.ids;
      this.delayForm.spaceId = this.temporarySearch.parkingLotId;
      this.showDelayDialogFlag = true;
    },
    handleDelay2() {
      //延期
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.delayForm.ids = this.ids;
      this.delayForm.spaceId = this.temporarySearch.parkingLotId;
      this.showDelayDialogFlag = true;
    },
    submitDelay(form, done) {
      delayBlacklist(this.delayForm).then(
        () => {
          this.$message.success('延期成功!');
          this.onLoad();
          this.showDelayDialogFlag = false;
          done();
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    cancelDelay() {
      console.log('取消');
      this.showDelayDialogFlag = false;
    },
    handleImport() {
      //导入
      this.importForm.parkingLotId = this.searchForm.parkingLotId;
      this.showImportDialogFlag = true;
    },
    handleImport2() {
      //导入
      this.importForm.parkingLotId = this.searchForm.parkingLotId;
      this.showImportDialogFlag = true;
    },
    handleSync() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定下发所选黑名单车辆信息到对应车场终端?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return syncBlacklist({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    rowSave(row, done, loading) {
      if (!row.imgUrl) {
        row.imgUrl = '';
      }
      add(row).then(
        () => {
          this.onLoad();
          this.onLoad2();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      if (!row.imgUrl) {
        row.imgUrl = '';
      }
      update(row).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        },
        (error) => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.onLoad2();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    handleDelete2() {
      if (this.selectionList2.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad2();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      } else if ('add' === type) {
        // const column = this.findObject(this.option.column, 'parkingLotId');
        // column.value = this.query.parkingLotId;
        this.form.parkAreaRightType =0
        this.form.blackType =Number(this.activeName)
      }
      done();
    },
    searchReset() {
      this.query = {};
      //每次刷新页面时，开启车场搜索框默然显示第一个节点的名称
      this.firstDisplayFlag = true;
      this.onLoad();
    },
    searchChange(params, done) {
      this.query.plateNumber=params.plateNumber
      this.query.driverName=params.driverName
      this.query.companyName=params.companyName
      this.query.plateNumber=params.plateNumber
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    searchRecord(){
      if(this.activeName=='0'){
        this.page.currentPage = 1;
        this.searchForm.blackType =0
        this.onLoad();
      }else{
        this.page2.currentPage = 1;
        this.searchForm.blackType =1
        this.onLoad2();
      }
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },


    searchReset2() {
      this.query2 = {};
      //每次刷新页面时，开启车场搜索框默然显示第一个节点的名称
      this.firstDisplayFlag = true;
      this.onLoad2();
    },
    searchChange2(params, done) {
      // this.query2 = params;
      this.query2.plateNumber=params.plateNumber
      this.query2.driverName=params.driverName
      this.query2.companyName=params.companyName
      this.query2.plateNumber=params.plateNumber
      this.page2.currentPage = 1;
      this.onLoad2();
      done();
    },
    currentChange2(currentPage) {
      this.page2.currentPage = currentPage;
    },
    sizeChange2(pageSize) {
      this.page2.pageSize = pageSize;
    },
    onLoad() {
      console.log("查询白名单车辆》》》》》》")
      if(this.searchForm.parkingLotId==""){
        return
      }

      this.loading = true;
      this.exportForm=this.searchForm
      this.temporarySearch  =this.searchForm
      getList(Object.assign({ current: this.page.currentPage, size: this.page.pageSize }, this.searchForm)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          if(this.spaceList.length > 0){
          var spaceColumn = this.findObject(this.option.column, 'parkingLotId');
          spaceColumn.dicData = this.spaceList;
        }
        this.$forceUpdate()
        }
      );
    },
    onLoad2() {
      if(this.searchForm.parkingLotId==""){
        return
      }
      this.loading = true;
      this.exportForm=this.searchForm
      getList(Object.assign({ current: this.page2.currentPage, size: this.page2.pageSize }, this.searchForm)).then(
        ({ data }) => {
          this.page2.total = data.total;
          this.data2 = data.records;
          this.loading = false;
          if(this.spaceList.length > 0){
          var spaceColumn = this.findObject(this.option.column, 'parkingLotId');
          spaceColumn.dicData = this.spaceList;
        }
          this.$forceUpdate()
        }
      );
    },
  },
};
</script>

<style>
.el-date-editor .el-range-separator {
  width: 10%;
}
#delayDialog .el-dialog {
  width: 30%;
}
#importDialog .el-dialog {
  width: 30%;
}
.avue-upload--upload .el-upload,
.avue-upload--upload .el-upload__tip,
.avue-upload__dialog .el-dialog__header {
  display: block;
}
</style>
<style lang="scss">
#parkblacklist20220108 {
  .avue-form__menu--center {
    text-align: right;
  }
  .avue-crud__search .el-form-item--small.el-form-item {
    width: 100%;
  }
}
</style>
